module.exports = __webpack_public_path__ + "d30a5081.png";